export default __webpack_public_path__ + "1834a0572abc7d5d072c8cd2fd2573d1.woff";